export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BRAND = {
  name: "Estate Paradise",
  tagline: "Real Estate Brokers",
  phone: "+91 9718251215",
  phoneRaw: "919718251215",
  email: "estateparadise81@gmail.com",
  address: "Shop No. 17, Gaur City 2, 14th Avenue, Greater Noida West",
  instagram: "https://www.instagram.com/estateparadise_?obrf=dzd0NHZkaTZqMXN1",
  instagramHandle: "@estateparadise_",
  youtube: "https://www.youtube.com/@ESTATE_PARADISE",
  youtubeHandle: "@ESTATE_PARADISE",
};

export const waLink = (text) =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT = waLink(
  "Hi Estate Paradise, I am interested in property details."
);

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/projects", label: "Pre-Launch Projects" },
  { to: "/resale", label: "Buy & Resale" },
  { to: "/rentals", label: "Rental Properties" },
  { to: "/contact", label: "About & Contact" },
];

const U = (id, ix) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&ixid=${ix}&ixlib=rb-4.1.0&q=85`;

export const IMG = {
  hero: "/hero-cover.jpg",
  living: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzkyMDQ4MjU1fDA&ixlib=rb-4.1.0&q=85",
  arch: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwcmVuZGVyaW5nJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzkyMDQ4MjU2fDA&ixlib=rb-4.1.0&q=85",
  trust: "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoYW5kc2hha2UlMjBidXNpbmVzcyUyMHRydXN0fGVufDB8fHx8MTc5MjA0ODI1NXww&ixlib=rb-4.1.0&q=85",
  tower1: "https://images.unsplash.com/photo-1551128997-c2b66772f982?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBoaWdoJTIwcmlzZSUyMHJlc2lkZW50aWFsJTIwdG93ZXIlMjBkdXNrfGVufDB8fHx8MTc5MjA0ODQ5OXww&ixlib=rb-4.1.0&q=85",
  tower2: "https://images.unsplash.com/photo-1674857567490-290dd93aaa62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBoaWdoJTIwcmlzZSUyMHJlc2lkZW50aWFsJTIwdG93ZXIlMjBkdXNrfGVufDB8fHx8MTc5MjA0ODQ5OXww&ixlib=rb-4.1.0&q=85",
  tower3: "https://images.unsplash.com/photo-1624204386084-dd8c05e32226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBoaWdoJTIwcmVzaWRlbnRpYWwlMjB0b3dlciUyMGR1c2t8ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  resale1: "https://images.unsplash.com/photo-1738168246881-40f35f8aba0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMHByZW1pdW18ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  resale2: "https://images.unsplash.com/photo-1753911372224-2b56c07cc737?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMHByZW1pdW18ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  resale3: "https://images.unsplash.com/photo-1761679296910-0a0078baa1ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxicmlnaHQlMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMHByZW1pdW18ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  resale4: "https://images.unsplash.com/photo-1761679296778-7f245d39148d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxicmlnaHQlMjBtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMHByZW1pdW18ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  rental1: "https://images.unsplash.com/photo-1661796428215-04fc2830aae6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxmdXJuaXNoZWQlMjBjb3p5JTIwYXBhcnRtZW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  rental2: "https://images.unsplash.com/photo-1613575831056-0acd5da8f085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxmdXJuaXNoZWQlMjBjb3p5JTIwYXBhcnRtZW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  rental3: "https://images.unsplash.com/photo-1678895223308-da40c609e39b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxmdXJuaXNoZWQlMjBjb3p5JTIwYXBhcnRtZW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  rental4: "https://images.unsplash.com/photo-1665249934445-1de680641f50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxmdXJuaXNoZWQlMjBjb3p5JTIwYXBhcnRtZW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkyMDQ4NDk5fDA&ixlib=rb-4.1.0&q=85",
  skyline: "https://images.unsplash.com/photo-1727942019403-cf4aecfc3276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHx1cmJhbiUyMGNpdHklMjBza3lsaW5lJTIwc3Vuc2V0fGVufDB8fHx8MTc5MjA0ODQ5OXww&ixlib=rb-4.1.0&q=85",
};

export const BUDGET_OPTIONS = [
  "Under ₹50 Lakh",
  "₹50 Lakh – ₹75 Lakh",
  "₹75 Lakh – ₹1 Cr",
  "₹1 Cr – ₹2 Cr",
  "Above ₹2 Cr",
];

export const RENTAL_BUDGET_OPTIONS = [
  "Under ₹20,000",
  "₹20,000 – ₹30,000",
  "₹30,000 – ₹45,000",
  "₹45,000 – ₹60,000",
  "Above ₹60,000",
];

export const INTEREST_OPTIONS = [
  "Pre-Launch Investment",
  "Buy / Resale Flat",
  "Rental Property",
  "Schedule Site Visit",
];
